import { Component } from "react"
import PropTypes from "prop-types"

export default class BrandingAsset extends Component {
  constructor(props) {
    super(props)
    this.state = { error: false }
    this.imageError = this.imageError.bind(this)
    this.markFailedAsset = this.props.markFailedAsset
  }

  imageError() {
    this.setState({ error: true })
    this.markFailedAsset(this.props.fieldKey)
  }

  assetStyle() {
    const style = {}
    if (this.props.type === "image-with-background") {
      style["backgroundColor"] = `#${this.props.review.channel.color_hsl}`
    }
    return style
  }

  render() {
    let asset
    if (this.state.error) {
      asset = <span>Missing value</span>
    } else {
      asset = (
        <img
          src={this.props.value}
          alt={this.props.service.name}
          style={this.assetStyle()}
          onError={this.imageError}
        />
      )
    }
    return asset
  }
}

BrandingAsset.propTypes = {
  review: PropTypes.object,
  service: PropTypes.object,
  fieldKey: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  markFailedAsset: PropTypes.func,
}
